import { InputCheckboxItemFreeComponent } from './input-checkbox-item-free.component';

export default angular
  .module('sfMobile.components.input-checkbox-item-free', [
    'sfMobile.services.popup',
    'sfMobile.components.input-checkbox',
  ])
  .component('sfInputCheckboxItemFree', InputCheckboxItemFreeComponent).name;
